import React, { createContext, useState, useContext, Dispatch, SetStateAction } from "react";
import { DeviceInfoDictionary } from "../interfaces/DeviceInfo";
import { Installation, InstallationCoords } from "../interfaces/Installation";
import { FeedMessageDictionary } from "../interfaces/Lifefeed";

export interface GlobalStateInterface {
  username: string
  name: string
  language : string
  organizationIdentifier:string
  organizationName:string
  organizationDisplayName:string
}

const globalStateContext = createContext({
  state: {} as Partial<GlobalStateInterface>,
  setState: {} as Dispatch<SetStateAction<Partial<GlobalStateInterface>>>,
});

const GlobalStateProvider = ({
  children,
  value = {} as GlobalStateInterface,
}: {
  children: React.ReactNode;
  value?: Partial<GlobalStateInterface>;
}) => {
  const [state, setState] = useState(value);
  return (
    <globalStateContext.Provider value={{ state, setState }}>
      {children}
    </globalStateContext.Provider>
  );
};

const useGlobalState = () => {
  const context = useContext(globalStateContext);
  if (!context) {
    throw new Error("useGlobalState must be used within a GlobalStateContext");
  }
  return context;
};

export { GlobalStateProvider, useGlobalState };